// Public market data only. No trading credentials or Tatum credits are used.
// https://github.com/binance/binance-spot-api-docs/blob/master/web-socket-streams.md
const SYMBOLS = ["BTC", "ETH", "BNB", "SOL", "XRP", "DOGE", "ADA", "AVAX", "DOT", "LINK", "LTC", "MATIC", "SHIB", "TRX", "UNI"];
export const STREAM_URL = "wss://data-stream.binance.vision/stream?streams=" + SYMBOLS.map((s) => `${s.toLowerCase()}usdt@miniTicker`).join("/");
const listeners = new Set();
let socket, retry, heartbeat, attempt = 0;
let quotes = {};
let lastActivity = 0;
const publish = () => listeners.forEach((fn) => fn({ ...quotes }));

export function parseQuote(raw, previous) {
  const item = raw?.data;
  if (!item || item.e !== "24hrMiniTicker" || !SYMBOLS.some((s) => item.s === `${s}USDT`)) return null;
  const price = Number(item.c), open = Number(item.o), high = Number(item.h), low = Number(item.l), time = Number(item.E);
  if (![price, open, high, low, time].every(Number.isFinite) || Math.min(price, open, high, low) <= 0 || time <= 0 || time > Date.now() + 60000 || (previous && time <= previous.time)) return null;
  return { symbol: item.s.slice(0, -4), price, change24h: (price / open - 1) * 100, high24h: high, low24h: low, time,
    receivedAt: Date.now(), source: "binance", sparkline: [...(previous?.sparkline || []), price].slice(-120) };
}

function connect() {
  if (!listeners.size) return;
  const schedule = () => {
    if (listeners.size && !retry) retry = setTimeout(() => { retry = null; connect(); }, Math.min(30000, 1000 * 2 ** Math.min(attempt++, 5)));
  };
  try {
    const ws = new WebSocket(STREAM_URL);
    socket = ws;
    lastActivity = Date.now();
    ws.onmessage = (event) => {
      if (socket !== ws) return;
      try {
        const raw = JSON.parse(event.data);
        const symbol = raw?.data?.s?.slice(0, -4);
        const quote = parseQuote(raw, quotes[symbol]);
        if (quote) { quotes = { ...quotes, [quote.symbol]: quote }; lastActivity = Date.now(); attempt = 0; publish(); }
      } catch { /* Malformed messages never become chart points. */ }
    };
    ws.onerror = () => ws.close();
    ws.onclose = () => { if (socket === ws) { socket = null; publish(); schedule(); } };
  } catch { schedule(); }
}

export function subscribeQuotes(listener) {
  listeners.add(listener);
  listener({ ...quotes });
  if (listeners.size === 1) {
    connect();
    // Notify views when a feed becomes stale, even if no further tick arrives.
    heartbeat = setInterval(() => {
      publish();
      if (socket && Date.now() - lastActivity > 30000) socket.close();
      if (!socket && !retry) connect();
    }, 5000);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      clearTimeout(retry); retry = null; clearInterval(heartbeat);
      const old = socket; socket = null; old?.close(); attempt = 0;
    }
  };
}

export function mergeQuotes(coins, updates, time = Date.now()) {
  return coins.map((coin) => {
    const quote = updates[coin.symbol];
    const recent = quote && time - quote.receivedAt <= 15000 && time - quote.time <= 30000;
    if (!quote) return { ...coin, live: false };
    return { ...coin, ...quote, live: !!recent, quote_currency: "USDT" };
  });
}
